import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface NavbarProps {
  alwaysSolid?: boolean;
}
export function Navbar({
  alwaysSolid = false
}: NavbarProps) {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const showSolid = alwaysSolid || isScrolled;
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Meet Elizabeth',
    href: '/about'
  }, {
    name: 'About VA-7',
    href: '/district'
  }, {
    name: 'Volunteer',
    href: '/volunteer'
  }, {
    name: 'Media\nToolkit',
    href: '/media'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${showSolid ? 'bg-navy shadow-lg py-3' : 'bg-navy/80 backdrop-blur-sm py-5'}`} data-id="element-149">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex justify-between items-center" data-id="element-150">
        <a href="/" className="flex items-center gap-3 group" data-id="element-151">
          <img src="https://cdn.magicpatterns.com/uploads/9c4e7vYPBAjAafuRJRjWho/Guzman_Congress_Logo_FINAL-reverse-alt.svg" alt="Elizabeth Guzmán - Democrat for Congress" className="h-[7.5rem] object-contain" data-id="element-152" />
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-3" data-id="element-153">
          {navLinks.map(link => <a key={link.name} href={link.href} className="font-bold text-xs tracking-widest uppercase transition-colors hover:text-sky text-white/90 whitespace-nowrap text-center leading-relaxed" data-id="element-154">
              {link.name.split('\n').map((line, i) => <span key={i} data-id="element-155">
                  {i > 0 && <br data-id="element-156" />}
                  {line}
                </span>)}
            </a>)}
          <a href="https://secure.actblue.com/donate/guzman_va_web" target="_blank" rel="noopener noreferrer" className="bg-red hover:bg-red-light text-white font-bold text-sm tracking-widest uppercase px-6 py-3 rounded-sm transition-colors shadow-sm" data-id="element-157">
            Donate
          </a>
        </nav>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden p-2" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-158">
          {isMobileMenuOpen ? <X className="text-white" size={28} data-id="element-159" /> : <Menu className="text-white" size={28} data-id="element-160" />}
        </button>
      </div>

      {/* Mobile Nav */}
      <AnimatePresence data-id="element-161">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-white border-t border-gray-100 shadow-xl overflow-hidden" data-id="element-162">
            <div className="flex flex-col px-6 py-6 gap-6" data-id="element-163">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="font-medium text-navy text-lg tracking-wide hover:text-sky transition-colors" data-id="element-164">
                  {link.name}
                </a>)}
              <a href="https://secure.actblue.com/donate/guzman_va_web" target="_blank" rel="noopener noreferrer" onClick={() => setIsMobileMenuOpen(false)} className="bg-red text-white font-bold text-center tracking-widest uppercase px-6 py-4 rounded-sm mt-2 hover:bg-red-light transition-colors" data-id="element-165">
                Donate Now
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}